module.exports = __webpack_public_path__ + "static/Ipad1-30446f7013f0c1781eb70841d3c31e63.png";